import { DownloadOutlined } from "@ant-design/icons";
import { Steps, Tabs } from "antd";
import { saveAs } from "file-saver";
import json2csv from "json2csv";
import moment from "moment";
import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  Cancel,
  cancle_order,
  DownloadPI,
  download_pi,
  GetOrder,
  get_order,
  OrderAddComments,
  OrderRepeat,
  OrderUpdate,
  order_add_comments,
  order_get_comments,
  order_history,
  order_repeat as orderRepeat,
  order_update,
  Products,
  store_addr_details,
  //UploadProfomaDoc,
  //upload_proforma_doc,
} from "../../actions/orders";
import close from "../../assets/cancel.svg";
import edit from "../../assets/edit.svg";
import message from "../../assets/message.svg";
import refresh from "../../assets/refresh.svg";
import PopupComponent from "../../common/Popup";
import { downloadPDF, hasOnlyView, getAccessLevel } from "../../config/helper";
import { NavWrap } from "../ShopForTyres";
import ProdDetailTable from "./ProdDetailTable";
import { ScaleLoader } from "react-spinners";

const { Step } = Steps;
const { TabPane } = Tabs;

const MyOrderWrap = (props) => {
  const location = useLocation();
  const history = useHistory();
  const update_order = useSelector((state) => state?.orders?.update_order);
  const order = useSelector((state) =>
    location?.state?.isEportal
      ? location?.state?.order
      : state?.orders?.single?.data?.order
  );
  const order_repeat = useSelector((state) => state?.orders?.order_repeat);
  // const upload_perfoma_doc = useSelector(
  //   (state) => state.orders.upload_perfoma_doc
  // );
  const params = useParams();
  const dispatch = useDispatch();
  const isMyOrdersReadOnly = hasOnlyView("my_orders");
    const access = getAccessLevel("new_order");
    const isViewOnly = access === "view_only";
    const noAccess = access === "none";
  return (
    <div className="order-wrap">
      <div className="flex-between">
        <div className="left-sec">
          <label>{props.label}</label>
          {!props.isEdit && props.showEdit && order?.id && (
            <button
              disabled={isMyOrdersReadOnly}
              className="w6"
              onClick={() => {
                props.setIsEdit(true);
              }}
            >
              <img src={edit} alt="icon" width={15} className="mr" />
              Edit
            </button>
          )}
        </div>
        <div className="right-sec">
          {props.isEdit && order?.id ? (
            <>
              <button
                disabled={isMyOrdersReadOnly}
                className="cancel-btn"
                onClick={() => {
                  props.setIsEdit(false);
                  dispatch({
                    type: Products.CHANGED,
                    isQuantity: true,
                  });
                  let obj = {
                    email: localStorage.getItem("email"),
                  };
                  if (location.state?.order_id) {
                    obj.orderId = params?.id
                      ? params?.id
                      : location.state?.order_number;
                  }

                  if (location.state?.so_number) {
                    obj.so_number = location.state?.so_number;
                  }
                  dispatch(get_order(obj));
                }}
              >
                Cancel
              </button>
              <button
                className={`re-order ${update_order?.loading ? "loadBtn" : ""}`}
                disabled={ isMyOrdersReadOnly || !props.isSaveReady}
                onClick={() => props.onSave()}
              >
                Save Order
              </button>
            </>
          ) : (
            <>
              {props.showCancel && order?.id && (
                <button
                  disabled={isMyOrdersReadOnly}
                  className="re-order"
                  onClick={() => {
                    props.cancelOrder();
                  }}
                >
                  Cancel order
                </button>
              )}
              {props.isSO && !props.downloadPi && (
                <button
                  className="re-order"
                  onClick={() => {
                    props.performa_inv();
                  }}
                  disabled={ isMyOrdersReadOnly || order_repeat?.loading}
                >
                  View & Sign Proforma
                </button>
              )}
              {props.downloadPi && (
                <button
                //disabled={isMyOrdersReadOnly}
                  className="re-order"
                  onClick={() => {
                    downloadPDF(props.downloadPi, "Signed_Proforma_Doc");
                  }}
                >
                  Download Signed Proforma
                </button>
              )}
              {/* Replaced Upload button with new Digital Signature flow as per CR */}
              {/* {props.isSO && (
                <>
                  <input
                    id="file"
                    className="d-none"
                    type={"file"}
                    onChange={(e) => {
                      let formData = new FormData();
                      formData.append("so_number", props.so_number);
                      formData.append("files", e.target.files[0]);
                      dispatch(upload_proforma_doc(formData));
                    }}
                  />
                  <button
                    className="re-order"
                    onClick={() => {
                      document.getElementById("file").value = "";
                      document.getElementById("file").click();
                    }}
                    disabled={upload_perfoma_doc?.loading}
                  >
                    {upload_perfoma_doc?.loading ? "Uploading" : "Upload"}{" "}
                    Signed Proforma Doc
                  </button>
                </>
              )} */}
              {order?.id && (
                <button
                  className="re-order nm"
                  onClick={() => {
                    props.reOrder();
                  }}
                  disabled={ isViewOnly || noAccess || order_repeat?.loading}
                >
                  <img src={refresh} alt="" />
                  Re-Order
                </button>
              )}
              {/* <button>
                More
                <img src={down} alt="icon" width={10} className="ml" />
              </button>
              <button>
                <img src={refresh} alt="icon" width={12} className="mr" />
                Sync Information
              </button> */}
            </>
          )}
          <button
            className="re-order nm"
            disabled={props?.loading || !props?.prod_data?.length}
            onClick={() => {
              let prods = props?.prod_data?.map((ele) => ({
                SKU: ele.SKU,
                Rim: ele.rim,
                Size: ele.Size,
                LI: ele.li,
                SR: ele.sr,
                LR: ele.lr,
                Pattern: ele.Pattern,
                Category: ele.category,
                Application: ele.appliction,
                "Sales Order": order?.so_number
                  ? order?.so_number
                  : order?.order_number,
                "Customer PO": order?.po_number,
                "Unit Price": parseFloat(ele?.["Unit Price"]).toFixed(2),
                "Quantity Ordered": ele.Quantity,
                Amount: parseFloat(ele.Amount).toFixed(2),
              }));
              let csv = json2csv.parse(prods);
              var blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
              saveAs(blob, "OrderProductList.csv");
            }}
          >
            <DownloadOutlined color="#333" />
          </button>
          <span
            className="close"
            onClick={() => {
              history.push("/orders", {
                filters: location?.state?.filters,
              });
            }}
          >
            <img src={close} alt="icon" width={18} />
          </span>
        </div>
      </div>
      {props.children}
    </div>
  );
};

const OrderDetail = () => {
  const location = useLocation();
  const params = useParams();
  const dispatch = useDispatch();
  const order = useSelector((state) =>
    location?.state?.isEportal
      ? location?.state?.order
      : state?.orders?.single?.data?.order
  );
  const orderMsg = useSelector((state) => state?.orders?.single?.data?.message);
  const orderLoading = useSelector((state) => state?.orders?.single?.loading);
  const order_comment = useSelector(
    (state) => state?.orders?.order_add_comments
  );
  const order_comments = useSelector(
    (state) => state?.orders?.order_get_comments?.data?.comments
  );
  const update_order = useSelector((state) => state?.orders?.update_order);
  const order_repeat = useSelector((state) => state?.orders?.order_repeat);
  const order_cancel = useSelector((state) => state?.orders?.order_cancel);
  const downloadpi = useSelector((state) => state?.orders?.download_pi);
  const orderHistory = useSelector(
    (state) => state?.orders?.order_history?.data
  );

  const [isEdit, setIsEdit] = useState(false);
  const [tab, setTab] = useState("1");
  const [comment, setComment] = useState("");
  const [cancelModal, setCancelModal] = useState(false);
  const [cancelComment, setCancelComment] = useState("");
  const [products, setProducts] = useState([]);
  const downloadPiLastSoNumber = useRef();
  const history = useHistory();
  // const upload_perfoma_doc = useSelector(
  //   (state) => state.orders.upload_perfoma_doc
  // );
  const [addNewProds, setAddNewProds] = useState([]);

  // useEffect(() => {
  //   if (upload_perfoma_doc?.success) {
  //     toast.success(upload_perfoma_doc?.data?.message);
  //     dispatch({
  //       type: UploadProfomaDoc.RESET,
  //     });
  //     if (order?.so_number) {
  //       dispatch(
  //         download_pi({
  //           email: localStorage.getItem("email"),
  //           authentication_token: localStorage.getItem("token"),
  //           file_id: order?.so_number,
  //         })
  //       );
  //     }
  //     // history.goBack()
  //     dispatch(
  //       get_order({
  //         email: localStorage.getItem("email"),
  //         authentication_token: localStorage.getItem("token"),
  //         orderId: params?.id ? params?.id : location.state?.order_number,
  //       })
  //     );
  //   }

  //   // eslint-disable-next-line
  // }, [upload_perfoma_doc]);

  useEffect(() => {
    let obj = {
      email: localStorage.getItem("email"),
    };
    if (
      location.state &&
      (location.state?.order_id || location.state?.so_number)
    ) {
      dispatch({
        type: GetOrder.RESET,
      });

      if (location.state?.order_id) {
        obj.orderId = params?.id ? params?.id : location.state?.order_number;
      }

      if (location.state?.so_number) {
        obj.so_number = true;
        obj.orderId = location.state?.so_number;
      }
      dispatch(get_order(obj));
    }

    if (params?.id) {
      obj.orderId = params?.id;
      dispatch(get_order(obj));
    }

    if (location.state?.order) {
      dispatch({
        type: GetOrder.SUCCESS,
        payload: {
          order: location.state?.order,
        },
      });
    }
    // eslint-disable-next-line
  }, [location.state]);

  useEffect(() => {
    return () => {
      dispatch({
        type: Products.CHANGED,
        isQuantity: true,
      });
      dispatch({
        type: DownloadPI.RESET,
      });
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const navSoNumber = location.state?.so_number;
    const navOrderNumber = location.state?.order_number;
    const reduxSoNumber = order?.so_number;
    const reduxOrderNumber = order?.order_number;

    // Only call download_pi if so_number is present and hasn't been called for this so_number
    if (
      reduxSoNumber &&
      (
        reduxSoNumber === navSoNumber ||
        reduxOrderNumber === navOrderNumber ||
        (!navSoNumber && !navOrderNumber) // fallback: if navigation state is missing, still allow
      ) &&
      downloadPiLastSoNumber.current !== reduxSoNumber
    ) {
      dispatch(
        download_pi({
          email: localStorage.getItem("email"),
          file_id: reduxSoNumber,
        })
      );
      downloadPiLastSoNumber.current = reduxSoNumber;
    }
    if (order?.id) {
      dispatch(
        order_get_comments({
          email: localStorage.getItem("email"),
          order_id: order?.id,
        })
      );
    }

    if (!order && !orderLoading && orderMsg) {
      dispatch({
        type: GetOrder.RESET,
      });
    }
    // eslint-disable-next-line
  }, [order]);

  useEffect(() => {
    if (update_order?.success) {
      toast.success(update_order?.data?.message);
      dispatch(
        get_order({
          email: localStorage.getItem("email"),
          orderId: params?.id ? params?.id : location.state?.order_number,
        })
      );
      setProducts([]);
      setAddNewProds([]);
      setIsEdit(false);
      dispatch({
        type: OrderUpdate.RESET,
      });
    }

    if (update_order?.success === false) {
      if (update_order?.data?.error_details?.length > 0) {
        toast.error(update_order?.data?.error_details?.join("\n"));
        dispatch({
          type: OrderUpdate.RESET,
        });
      }
    }
    // eslint-disable-next-line
  }, [update_order]);

  useEffect(() => {
    if (order_repeat?.success) {
      toast.success("Items added to cart successfully");
      localStorage.setItem("cartId", order_repeat?.data?.cart?.id);
      dispatch({
        type: OrderRepeat.RESET,
      });
      dispatch(
        store_addr_details({
          shipping_address_id: order?.delivery_address?.id,
        })
      );
      history.push("/cart");
    }
    if (order_repeat?.data?.status === false) {
      toast.error("Failed to re-order.");
      dispatch({
        type: OrderRepeat.RESET,
      });
    }
    // eslint-disable-next-line
  }, [order_repeat]);

  useEffect(() => {
    if (order_cancel?.success) {
      toast.success("Order cancelled successfully");
      // setCancelModal(false);
      setCancelComment("");
      dispatch({
        type: Cancel.RESET,
      });
      history.push("/orders");
    }
    if (order_cancel?.data?.status === false) {
      toast.error("Failed to cancel order.");
      dispatch({
        type: Cancel.RESET,
      });
    }
    // eslint-disable-next-line
  }, [order_cancel]);

  useEffect(() => {
    if (order_comment?.success) {
      toast.success("Commented Successfully.");
      setComment("");
      dispatch(
        order_get_comments({
          email: localStorage.getItem("email"),
          order_id: order?.id,
        })
      );
      dispatch({
        type: OrderAddComments.RESET,
      });
    }

    if (
      order_comment?.data?.status === false ||
      order_comment?.success === false
    ) {
      toast.error("Failed to add Comment.");
      dispatch({
        type: OrderAddComments.RESET,
      });
    }
    // eslint-disable-next-line
  }, [order_comment]);

  const order_status = {
    Confirmed: "success-text",
    Completed: "success-text",
    Accepted: "success-text",
    "Awaiting signature": "warn-text",
    "To be confirmed": "warn-text",
    Pending: "warn-text",
    Cancelled: "error-text",
  };

  const getAddress = (name) => {
    if (order?.order_sales_nav?.Street) {
      return (
        <>
          <p>
            {name ? (
              <>
                {order?.order_sales_nav?.Name1}
                <br />
              </>
            ) : null}
            {order?.order_sales_nav?.Street}
            {order?.order_sales_nav?.Street && ", "}
            {order?.order_sales_nav?.City1}
            {order?.order_sales_nav?.City1 && ", "}
            <br />
            {order?.order_sales_nav?.Country}
            {order?.order_sales_nav?.Country && ", "}
            {order?.order_sales_nav?.PostCode1}
            <br /> PH : {order?.order_sales_nav?.TelNumber}
          </p>
        </>
      );
    } else {
      return (
        <p>
          {order?.delivery_address?.name}
          <br />
          {order?.delivery_address?.address1} ,{" "}
          {order?.delivery_address?.address2}
          <br />
          {order?.delivery_address?.city}, {order?.delivery_address?.state}{" "}
          {order?.delivery_address?.zip}
          <br /> PH : {order?.delivery_address?.phone}
        </p>
      );
    }
  };
  const checkOrderStatus = (item) => {
    if (item?.Augru !== "Z92" && item?.SoNumber && item?.OrderStatus === "C") {
      return "Completed";
    } else if (item?.Augru !== "Z92" && item?.SoNumber) {
      return "Confirmed";
    } else if (item?.Augru === "Z92") {
      return "Cancelled";
    } else return "To be confirmed";
  };
  const status = checkOrderStatus(order?.order_sales_nav);
  return (
    <NavWrap>
      <div className="card2 prod">
        <MyOrderWrap
          label={isEdit ? "Edit Order" : "Orders"}
          isEdit={isEdit}
          showEdit={
            status !== "Confirmed" &&
            !order?.cancelled_order &&
            order?.order_sales_nav?.Editable === "X"
          }
          setIsEdit={(bool) => {
            setIsEdit(bool);
          }}
          prod_data={order?.line_items}
          loading={orderLoading}
          onSave={() => {
            let filteredLineItems = order.line_items?.filter(
              (ele) => !ele.isChanged
            );
            filteredLineItems = filteredLineItems?.reduce(
              (prods = {}, currentValue) => {
                prods[currentValue?.product_id] = currentValue?.Quantity;
                return prods;
              },
              {}
            );

            let prods_new = [...products];
            prods_new = prods_new.reduce((prods = {}, currentValue) => {
              let prod_id = currentValue?.product_id?.includes("_new")
                ? currentValue?.product_id?.split("_new")[0]
                : currentValue?.product_id;
              if (prods[prod_id]) {
                if (currentValue?.unit_price) {
                  prods[prod_id] = [
                    (
                      Number(prods[prod_id]) + Number(currentValue?.quantity)
                    ).toString(),
                    currentValue?.unit_price,
                  ];
                } else {
                  prods[prod_id] = (
                    Number(prods[prod_id]) + Number(currentValue?.quantity)
                  ).toString();
                }
              } else {
                if (currentValue?.unit_price) {
                  prods[prod_id] = [
                    Number(currentValue?.quantity),
                    currentValue?.unit_price,
                    currentValue?.product_sku,
                  ];
                } else {
                  prods[prod_id] = Number(currentValue?.quantity);
                }
              }
              if (filteredLineItems[prod_id]) {
                if (currentValue?.unit_price) {
                  prods[prod_id] =
                    prods[prod_id][0] + (filteredLineItems[prod_id] || 0);
                } else {
                  prods[prod_id] =
                    prods[prod_id] + (filteredLineItems[prod_id] || 0);
                }
                delete filteredLineItems[prod_id];
              }
              return prods;
            }, {});
            dispatch(
              order_update({
                order_id: order?.id,
                products: Object.keys(prods_new).map((ele) =>
                  Array.isArray(prods_new[ele])
                    ? {
                        product_id: ele,
                        quantity: prods_new[ele][0],
                        unit_price: prods_new[ele][1],
                        product_sku: prods_new[ele][2],
                      }
                    : { product_id: ele, quantity: prods_new[ele] }
                ),
              })
            );
          }}
          isSaveReady={
            (order?.changed && order.line_items?.length > 0) ||
            addNewProds?.length > 0
          }
          reOrder={() => {
            dispatch(
              orderRepeat({
                order_id: order?.id,
                po_number: order?.po_number,
              })
            );
          }}
          cancelOrder={() => {
            setCancelModal(true);
          }}
          showCancel={
            !order?.cancelled_order &&
            status !== "Confirmed" &&
            order?.order_sales_nav?.Editable === "X"
          }
          isSO={order?.so_number}
          downloadPi={downloadpi?.data?.pdf_content}
          so_number={order?.so_number}
          performa_inv={() => {
            history.push("/performa-doc", {
              sales_order: order?.so_number,
              order_id: order?.id,
              order_no: order?.order_number,
              pi_status: order?.pi_status,
              amount: order?.total_price,
              time: order?.date,
            });
          }}
        >
          <div className="details">
            <div className="flex-between">
              <div>
                {order?.id && (
                  <span
                    className={`status ${
                      order_status[
                        order?.cancelled_order ? "Cancelled" : status
                      ]
                    }`}
                  >
                    {order?.cancelled_order ? "Cancelled" : status}
                  </span>
                )}
              </div>
              {/* <div className="nm">
                PI Status:{" "}
                <span className={`status ${order_status[order?.pi_status]}`}>
                  {order?.pi_status}
                </span>
              </div> */}
            </div>
            {orderLoading ? (
              <div className="flex-center">
                <ScaleLoader color={"#2f2d51"} />
              </div>
            ) : order?.order_number ? (
              <>
                <div>
                  <span className="nm large">
                    Sales Order - #
                    {order?.so_number ? order?.so_number : order?.order_number}
                  </span>
                </div>
                <div className="ord-details">
                  <div>
                    <div>
                      <span className="nm">
                        Customer PO Number -{" "}
                        {order?.order_sales_nav?.Bstnk ?? order?.po_number}
                      </span>
                    </div>
                    <div>
                      <span className="nm">
                        {"Date & Time : " +
                          moment(order?.date).format("DD/MM/YYYY HH:mm a")}
                      </span>
                    </div>
                    <div>
                      <span className="nm">
                        Created by : {order?.name} <br />
                        <span className="light">{order?.email}</span>
                      </span>
                    </div>
                  </div>
                  <div className="addr delivery">
                    <div>
                      <span className="nm">Delivery Address</span>
                    </div>
                    {typeof order?.delivery_address === "string" ? (
                      <p>{order?.delivery_address}</p>
                    ) : (
                      getAddress(true)
                    )}
                  </div>
                </div>
              </>
            ) : (
              <div className="content">
                <h1 className="nm large">Order Not Found</h1>
                <span>
                  Sorry, we couldn't find the order you were looking for.
                </span>
                <span>Please check the order number.</span>
                <span
                  className="link"
                  onClick={() => {
                    history.push("/orders");
                  }}
                >
                  Go Back to Orders
                </span>
              </div>
            )}
          </div>
          {order?.order_number ? (
            <div className="tabs mt1">
              <Tabs
                defaultActiveKey={"1"}
                onTabClick={(val) => {
                  setTab(val);
                  if (parseInt(val) === 3) {
                    dispatch(
                      order_history({
                        email: localStorage.getItem("email"),
                        order_id: params?.id
                          ? params?.id
                          : location.state?.order_number,
                      })
                    );
                  }
                }}
              >
                <TabPane active={tab} tab="Product Details" key="1">
                  <ProdDetailTable
                    data={order?.line_items}
                    order={order}
                    isEdit={isEdit && order?.order_sales_nav?.Editable === "X"}
                    products={products}
                    setProducts={setProducts}
                    addNewProds={addNewProds}
                    setAddNewProds={setAddNewProds}
                  />
                </TabPane>

                <TabPane active={tab} tab="Order Details" key="2">
                  <section className="od">
                    <div className="row">
                      <span>Delivery Address :</span>
                      {typeof order?.delivery_address === "string" ? (
                        <p>{order?.delivery_address}</p>
                      ) : (
                        getAddress(true)
                      )}
                    </div>
                    {/* <div className="row">
                    <span>Billing Address :</span>
                    <p>
                      M. Rajendran
                      <br /> Telecommunications Limited. 31 Exeter Road,
                      <br />
                      Comcentre, Singapore 239732
                      <br /> PH : +61 889890034
                    </p>
                  </div> */}
                    {/* <div className="row">
                    <span>Order type :</span>
                    <p>-</p>
                  </div>
                  <div className="row">
                    <span>Payment By :</span>
                    <p>Credit Balance</p>
                  </div> */}
                  </section>
                </TabPane>

                <TabPane active={tab} tab="History" key="3">
                  <div className="order-history">
                    {orderHistory &&
                    Array.isArray(orderHistory) &&
                    orderHistory?.length > 0 ? (
                      orderHistory?.map((ele) => {
                        return (
                          <div className="his-item">
                            <span>{ele?.date}</span>
                            <span>{ele?.message}</span>
                          </div>
                        );
                      })
                    ) : (
                      <div className="his-item">
                        <span>No History</span>
                      </div>
                    )}
                  </div>
                </TabPane>
              </Tabs>
            </div>
          ) : null}
          {order?.id && (
            <div className="d-flex gap2 mt1">
              <div className="w50">
                <div className="tabs">
                  <Tabs defaultActiveKey="1">
                    <TabPane tab="Comments">
                      <div className="comments">
                        <Steps size="small" direction="vertical">
                          {Array.isArray(order_comments) &&
                            order_comments?.map((ele) => {
                              return (
                                <Step
                                  title={
                                    <div className="comments">
                                      {ele?.Comments}
                                      <br />
                                      <span>
                                        By:{" "}
                                        {ele?.Createdby === "Omni Admin"
                                          ? "Omni Customer Service Team"
                                          : ele.Createdby}
                                      </span>
                                      <span>
                                        On:{" "}
                                        {moment(ele?.date).format(
                                          "DD/MM/YYYY HH:mm"
                                        )}
                                      </span>
                                    </div>
                                  }
                                  icon={<img src={message} alt="message" />}
                                />
                              );
                            })}
                        </Steps>
                        <div className="comment-wrap">
                          <form
                            onSubmit={(e) => {
                              e.preventDefault();
                              dispatch(
                                order_add_comments({
                                  order_id: order?.id,
                                  comment,
                                })
                              );
                            }}
                          >
                            <input
                              placeholder="Enter Text"
                              name="comment"
                              value={comment}
                              onChange={(e) => {
                                setComment(e.target.value);
                              }}
                            />
                            <button
                              className="green-btn"
                              disabled={order_comment?.loading || !comment}
                            >
                              Submit
                            </button>
                          </form>
                        </div>
                      </div>
                    </TabPane>
                  </Tabs>
                </div>
              </div>
              <div className="w50">
                <div className="tabs">
                  <Tabs defaultActiveKey="1">
                    <TabPane tab="Status">
                      <div className="status">
                        <div className="ml1 mt1">
                          <Steps
                            direction="vertical"
                            progressDot
                            current={
                              status === "Completed"
                                ? 3
                                : status !== "Confirmed"
                                ? 1
                                : 2
                            }
                          >
                            <Step
                              title={
                                <div className="box">
                                  Order has been placed successfully
                                </div>
                              }
                            />
                            <Step
                              title={
                                <div className="box">Awaiting Confirmation</div>
                              }
                            />
                            <Step
                              title={<div className="box">Confirmed</div>}
                            />
                            <Step
                              title={<div className="box">Completed</div>}
                            />
                          </Steps>
                        </div>
                      </div>
                    </TabPane>
                  </Tabs>
                </div>
              </div>
            </div>
          )}
        </MyOrderWrap>
        <PopupComponent open={cancelModal}>
          <div className="cancel-popup">
            <h3>Please confirm if you'd like to cancel this order ?</h3>
            {/* <Input placeholder="Enter comment (Optional)" onChange={(e) => {
              setCancelComment(e.target.value)
            }} value={cancelComment} /> */}
            <div className="cancel-btns mt2">
              <button
                className="cancel-btn mr2"
                onClick={() => {
                  setCancelModal(false);
                }}
              >
                {" "}
                Back
              </button>
              <button
                disabled={order_cancel?.loading}
                onClick={() => {
                  dispatch(
                    cancle_order({
                      order_id: order?.id,
                      comment: cancelComment,
                    })
                  );
                }}
                className="primary-btn"
              >
                Cancel
              </button>
            </div>
          </div>
        </PopupComponent>
      </div>
    </NavWrap>
  );
};

export default OrderDetail;
